export default function Header() {
    return (
        <header style={{ background: "#f0f7ff", padding: "10px 0", borderBottom: "1px solid #ddd" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src="/logoBuf.svg" alt="Logo" style={{ height: 40, marginRight: 10 }} />
                    <h1 style={{ fontSize: 20, margin: 0, color: "#007BFF" }}>BUFF</h1>
                </div>
            </div>
        </header>
    );
}
